// Date 2020-08-03 08:33:13

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/lifecycle/emLcAccInstAccRepIar/list",
        name: "emLcAccInstAccRepIarList",
        component: emWorkflowListView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAccInstAccRepIar/edit",
        name: "emLcAccInstAccRepIarEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAccInstAccRepIar/task",
        name: "emLcAccInstAccRepIarTask",
        component: emWorkflowTaskView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAccInstAccTypeIat/list",
        name: "emLcAccInstAccTypeIatList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAccInstAccTypeIat/edit",
        name: "emLcAccInstAccTypeIatEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAdjustedReportAdr/list",
        name: "emLcAdjustedReportAdrList",
        component: emWorkflowListView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAdjustedReportAdr/edit",
        name: "emLcAdjustedReportAdrEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcAdjustedReportAdr/task",
        name: "emLcAdjustedReportAdrTask",
        component: emWorkflowTaskView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcInstalledReportInr/list",
        name: "emLcInstalledReportInrList",
        component: emWorkflowListView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcInstalledReportInr/edit",
        name: "emLcInstalledReportInrEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcInstalledReportInr/task",
        name: "emLcInstalledReportInrTask",
        component: emWorkflowTaskView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcScrReasonSrea/list",
        name: "emLcScrReasonSreaList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcScrReasonSrea/edit",
        name: "emLcScrReasonSreaEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcScrRecordSre/list",
        name: "emLcScrRecordSreList",
        component: emWorkflowListView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcScrRecordSre/edit",
        name: "emLcScrRecordSreEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcScrRecordSre/task",
        name: "emLcScrRecordSreTask",
        component: emWorkflowTaskView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcSdSelectionDemSde/list",
        name: "emLcSdSelectionDemSdeList",
        component: emWorkflowListView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcSdSelectionDemSde/edit",
        name: "emLcSdSelectionDemSdeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/lifecycle/emLcSdSelectionDemSde/task",
        name: "emLcSdSelectionDemSdeTask",
        component: emWorkflowTaskView,
        meta: metaObject
    },
//自定义页面注册
]